import {createApp} from 'vue'
import App from '@/App.vue'
import router from '@/router';
import { createPinia } from "pinia";
import { customComponentPlugin } from "@/utils/global-component";
import vByteMax from '@/directives/v-byte-max';

const pinia = createPinia();

const app= createApp(App)
     .use(pinia)
     .use(router)
     .use(customComponentPlugin);

app.directive('byte-max', vByteMax);
app.mount('body')

export { pinia };
